import React, { useCallback, useState, useMemo } from 'react';
import { TInput } from '../input/input.types';
import { Input } from '../input/input';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

const InputPassword: React.FC<TInput> = ({ myRef, ...props }) => {
    const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false);

    const handleToggleVisibility = useCallback(() => {
        setIsPasswordVisible((isVisible) => !isVisible);
    }, []);

    const CurAdornmentIcon = useMemo(
        () => (isPasswordVisible ? VisibilityOffIcon : VisibilityIcon),
        [isPasswordVisible],
    );

    return (
        <Input
            myRef={myRef}
            {...props}
            inputProps={{
                ...props.inputProps,
                type: isPasswordVisible ? 'text' : 'password',
            }}
            adornment={{
                after: <CurAdornmentIcon onClick={handleToggleVisibility} />,
            }}
        />
    );
};

export default InputPassword;
